import RuejaiClubCategoryCreatePage from "./pages/RuejaiClubCategoryCreatePage";
import RuejaiClubCategoryListPage from "./pages/RuejaiClubCategoryListPage";
import RuejaiClubCategoryDetailPage from "./pages/RuejaiClubCategoryDetailPage";

export const ruejaiClubCategoryRoutes = (prefix = "categories") => [
  {
    name: "RuejaiClubCategoryCreatePage",
    path: `${prefix}/create`,
    component: RuejaiClubCategoryCreatePage
  },
  {
    name: "RuejaiClubCategoryDetailPage",
    path: `${prefix}/:id`,
    component: RuejaiClubCategoryDetailPage
  },
  {
    name: "RuejaiClubCategoryListPage",
    path: prefix,
    component: RuejaiClubCategoryListPage
  },
];
